import paginate from 'helpers/redux/paginate';
import { get } from 'lodash';
import { callGraphQLApi } from 'helpers/api';
import { reduceReducers, createReducer } from 'helpers/redux';

export const namespace = 'aiWare';

// const CREATE = "vtn/aiWare/CREATE";
export const CREATE_SUCCESS = 'vtn/aiWare/CREATE_SUCCESS';
export const CREATE_FAILURE = 'vtn/aiWare/CREATE_FAILURE';

// const DELETE = "vtn/application/DELETE";
export const DELETE_SUCCESS = 'vtn/application/DELETE_SUCCESS';
export const DELETE_FAILURE = 'vtn/application/DELETE_FAILURE';

export const LIST = 'vtn/aiWare/LIST';
export const LIST_SUCCESS = 'vtn/aiWare/LIST_SUCCESS';
export const LIST_FAILURE = 'vtn/aiWare/LIST_FAILURE';

export const FETCH_CLUSTERS = 'vtn/aiWare/FETCH_CLUSTERS';
export const FETCH_CLUSTERS_SUCCESS = 'vtn/aiWare/FETCH_CLUSTERS_SUCCESS';
export const FETCH_CLUSTERS_FAILURE = 'vtn/aiWare/FETCH_CLUSTERS_FAILURE';

export const CREATE_CLUSTER = 'vtn/aiWare/CREATE_CLUSTER';
export const CREATE_CLUSTER_SUCCESS = 'vtn/aiWare/CREATE_CLUSTER_SUCCESS';
export const CREATE_CLUSTER_FAILURE = 'vtn/aiWare/CREATE_CLUSTER_FAILURE';

export const DELETE_CLUSTER = 'vtn/aiWare/DELETE_CLUSTER';
export const DELETE_CLUSTER_SUCCESS = 'vtn/aiWare/DELETE_CLUSTER_SUCCESS';
export const DELETE_CLUSTER_FAILURE = 'vtn/aiWare/DELETE_CLUSTER_FAILURE';

const defaultState = {
  loading: false,
  loaded: true,
  clusters: []
};

const reducer = reduceReducers(
  paginate({
    types: [LIST, LIST_SUCCESS, LIST_FAILURE],
    invalidateOnTypes: [CREATE_SUCCESS, DELETE_SUCCESS],
    idAttribute: 'id'
  }),
  createReducer(defaultState, {
    [FETCH_CLUSTERS](state, action) {
      return {
        ...state,
        loading: true
      };
    },
    [FETCH_CLUSTERS_SUCCESS](state, action) {
      const clusters = get(action, 'payload.data.clusters.records', []);
      return {
        ...state,
        loading: false,
        loaded: true,
        clusters: clusters
      };
    }
  })
);

export default reducer;

function local(state) {
  return state[namespace];
}

export const getClusters = state => local(state).clusters;

export const fetchClusters = organiztionId => (dispatch, getState) => {
  const query = `
  query($organiztionId: ID!) {
    clusters(organizationId: $organiztionId) {
			records {
				id
				name
				createdDateTime
				status
			}
			count
		}
  }`;

  return callGraphQLApi({
    actionTypes: [
      FETCH_CLUSTERS,
      FETCH_CLUSTERS_SUCCESS,
      FETCH_CLUSTERS_FAILURE
    ],
    query,
    variables: {
      organiztionId
    },
    dispatch,
    getState
  });
};

export const createClusterService = ({ name, organizationId }) => (
  dispatch,
  getState
) => {
  const query = `
  mutation($name: String!, $organizationId: ID!) {
    createCluster(input:{
      name: $name,
      allowedEngines:[],
      dockerCredentials: {},
      organizationId: $organizationId,
    }){
      id
    }
  }`;

  return callGraphQLApi({
    actionTypes: [
      CREATE_CLUSTER,
      CREATE_CLUSTER_SUCCESS,
      CREATE_CLUSTER_FAILURE
    ],
    query,
    variables: {
      name,
      organizationId
    },
    dispatch,
    getState
  });
};

export const deleteClusterService = id => (dispatch, getState) => {
  const query = `
  mutation($id: ID!) {
    deleteCluster(id: $id){
      id
      message
    }
  }`;

  return callGraphQLApi({
    actionTypes: [
      DELETE_CLUSTER,
      DELETE_CLUSTER_SUCCESS,
      DELETE_CLUSTER_FAILURE
    ],
    query,
    variables: {
      id
    },
    dispatch,
    getState
  });
};



// WEBPACK FOOTER //
// ./src/client/modules/aiWare/index.js